// extracted by mini-css-extract-plugin
export var defaultWrapper = "_hf-3";
export var downloadButton = "_hf-4";
export var fileContainer = "_hf-9 _hf-7";
export var fileContainerBase = "_hf-7";
export var fileContainerBaseSm = "_hf-a _hf-7";
export var fileContainerFixedHeight = "_hf-8 _hf-7";
export var fileContainerFixedHeightSm = "_hf-c _hf-a _hf-7";
export var fileContainerSm = "_hf-b _hf-a _hf-7";
export var fileInfo = "_hf-5";
export var fileInfoWidthRestricted = "_hf-6";
export var fileType = "_hf-1";
export var fileTypeName = "_hf-2";
export var fileTypeSm = "_hf-d _hf-1";
export var image = "_hf-0";
export var link = "_hf-f";
export var overflowEllipsis = "_hf-e";